import { Button, Col, Row, Space, Switch, Typography } from 'antd';
import React, { FC, useState, useCallback, useEffect } from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import stylesModule from './SubscriptionTable.module.less';
import Router, { useRouter } from 'next/router';
import { useConnection } from '../../connection/Application';
import { ResponsiveModal } from '../ResponsiveModal/ResponsiveModal';
import moment from 'moment';
import { Spin } from 'antd/lib';
import Utils from '../../utils/Utils';
import SubscriptionChangeModal, { useSubscriptionChangeModal } from './SubscriptionChangeModal';
import classNames from 'classnames';
import { useRecruiter } from '../../page-components/Recruiiter/RecruiterContext';

export const AvailablePackages = {
  payAsYouGo: '6f063c91-19cb-462e-9055-96e1441e1a09',
  standard: {
    monthly: '90f4704e-14eb-471b-beb8-fea990dc472b',
    annually: '587ab69c-1dd3-4ed4-be7e-a7684c55e6e3',
  },
  premium: {
    monthly: '91657e56-5a75-4702-bf29-a3112849024a',
    annually: 'fc31a0f7-514b-42b2-9818-f633c7d07239',
  },
};

type Packages = {
  payAsYouGo: any;
  standard: { monthly: any; annually: any };
  premium: { monthly: any; annually: any };
};

const styles: any = stylesModule;
type Props = {
  onSelect?: (value: {
    subscription: string;
    monthly?: boolean;
    planId?: string;
    packageId?: string;
  }) => void;
  recruiterId?: string;
  planName?: string;
  hideSubscribe?: boolean;
  package?: any;
};
export const SubscriptionTable: FC<Props> = (props) => {
  const { onSelect, recruiterId, hideSubscribe } = props;
  const [monthly, setMonthly] = useState(true);
  const [amount1, setAmount1] = useState('LKR 12,500');
  const [amount2, setAmount2] = useState('LKR 35,000');
  const [month, setMonth] = useState('#009E60');
  const [year, setYear] = useState('#5A5D65');
  const [monthsize, setMonthsize] = useState(600);
  const [yearsize, setYearsize] = useState(200);
  const [packages, setPackages] = useState<Packages>({} as any);
  const [currentPackage, setCurrentPackage] = useState<any>();
  const [downgradeVisible, setDowngradeVisible] = useState(false);
  const [downgradeVisible1, setDowngradeVisible1] = useState(false);
  const [upgradeVisible, setUpgradeVisible] = useState(false);
  const [upgradeVisible1, setUpgradeVisible1] = useState(false);
  const [billingCycle, setBillingCycle] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<any>();
  const subChangeModal = useSubscriptionChangeModal();
  const recruiter = useRecruiter();
  const router = useRouter();
  const { query } = router;
  const connection = useConnection();

  const onChange = useCallback((checked: boolean) => {
    if (!checked) {
      setMonthly(true);
      setAmount1('LKR 12,500');
      setAmount2('LKR 35,000');
      setYear('#5A5D65');
      setMonth('#009E60');
      setMonthsize(600);
      setYearsize(200);
    } else {
      setMonthly(false);
      setAmount1('LKR 102,000');
      setAmount2('LKR 300,000');
      setMonth('#5A5D65');
      setYear('#009E60');
      setMonthsize(200);
      setYearsize(600);
    }
  }, []);

  const getPackages = useCallback(async () => {
    try {
      connection.get('packages').then((res) => {
        const pkgs = Object.fromEntries(res.map((v) => [v.key, v]));
        setPackages({
          payAsYouGo: pkgs[AvailablePackages.payAsYouGo],
          standard: {
            monthly: pkgs[AvailablePackages.standard.monthly],
            annually: pkgs[AvailablePackages.standard.annually],
          },
          premium: {
            monthly: pkgs[AvailablePackages.premium.monthly],
            annually: pkgs[AvailablePackages.premium.annually],
          },
        });
      });
    } catch (e) {
      console.log('Error', e);
    }
  }, [connection]);

  const getCurrentPackage = useCallback(() => {
    if (!props.package?.subscriptionId) {
      return;
    }
    try {
      connection.post('package', { planId: props.package?.subscriptionId }).then((res) => {
        setCurrentPackage(res);
        setMonthly(res.billing !== 'Annually');
        onChange(res.billing === 'Annually');
      });
    } catch (e) {
      console.log('Error', e);
    }
  }, [connection, onChange, props.package?.subscriptionId]);

  useEffect(() => {
    getPackages().catch(console.error);
    getCurrentPackage();
    if (!hideSubscribe) {
      if (recruiter && !recruiter.hasPermission('Change Subscription')) {
        router.replace(`/recruiter/${query?.id}/profile`);
      }
    }
  }, [getCurrentPackage, getPackages, hideSubscribe, query?.id, recruiter, router]);

  if ((!packages.payAsYouGo || !currentPackage) && props.package?.subscriptionId) {
    return <Spin spinning={true} />;
  }
  return (
    <div className={styles.tablecontainer}>
      <div className={styles.tableWrapper}>
        <table className={styles.sub}>
          <tbody>
            <tr>
              <th className={styles.toggleth}>
                {/* <p className={styles.toggle}>
                  Monthly <Space> </Space> <Switch onChange={onChange} /> <Space> </Space> Yearly
                </p> */}
              </th>
              <th className={styles.headpay} colSpan={2}>
                PAY AS YOU GO
              </th>
              <th className={styles.whiteborder} />
              <th className={styles.headsub} colSpan={3}>
                <Row>
                  <Col span={24} className={styles.tableTitleTxt}>
                    SUBSCRIPTION
                  </Col>
                  <Col span={24}>
                    <div className={styles.toggles}>
                      <p
                        className={styles.tableSubtitle}
                        style={{ color: month, fontWeight: monthsize }}>
                        Monthly
                      </p>{' '}
                      <Space> </Space>{' '}
                      <Switch
                        className={styles.togglecolor}
                        checked={!monthly}
                        onChange={onChange}
                        size={'small'}
                      />{' '}
                      <Space> </Space>
                      <p
                        className={styles.tableSubtitle}
                        style={{ color: year, fontWeight: yearsize }}>
                        {' '}
                        Yearly
                      </p>
                    </div>
                  </Col>
                </Row>
              </th>
            </tr>

            <tr>
              <th className={styles.secondcol} />
              <th colSpan={2} className={styles.head1}>
                <Row className={styles.secondRow}>
                  {/*<Col span={12}>LITE</Col>*/}
                  {/*<Col span={12}>BULK</Col>*/}
                  <Col span={24} className={styles.tableTitleTxt}>
                    No Monthly Cost
                  </Col>
                  {/*<Col span={12} className={styles.amountvalue}>*/}
                  {/*  N/A*/}
                  {/*</Col>*/}
                  <Col span={24} className={styles.amountvalue}>
                    LKR 2,000 Per Ad
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px', textAlign: 'center' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (currentPackage?.key === AvailablePackages.payAsYouGo) {
                            return;
                          }
                          subChangeModal.current?.show(AvailablePackages.payAsYouGo);
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage?.key !== AvailablePackages.payAsYouGo,
                        })}>
                        {currentPackage?.key === AvailablePackages.payAsYouGo
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>

              <th className={styles.whiteborder} />

              <th className={styles.stand1}>
                <Row className={styles.secondRow}>
                  <Col span={24} className={styles.tableTitleTxt}>
                    STANDARD
                  </Col>
                  <Col span={24} className={styles.amountvalue}>
                    {amount1}
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (
                            currentPackage?.key ===
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually']
                          ) {
                            return;
                          }
                          subChangeModal.current?.show(
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually'],
                          );
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage?.key !==
                            AvailablePackages.standard[monthly ? 'monthly' : 'annually'],
                        })}>
                        {currentPackage?.key ===
                        AvailablePackages.standard[monthly ? 'monthly' : 'annually']
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>

              <th className={styles.stand}>
                <Row className={styles.secondRow}>
                  <Col span={24} className={styles.tableTitleTxt}>
                    PREMIUM
                  </Col>
                  <Col span={24} className={styles.amountvalue}>
                    {amount2}
                  </Col>
                  {!hideSubscribe && (
                    <Col span={24} style={{ paddingTop: '5px', textAlign: 'center' }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (
                            currentPackage?.key ===
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually']
                          ) {
                            return;
                          }
                          subChangeModal.current?.show(
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually'],
                          );
                        }}
                        className={classNames({
                          [styles.buttonSelect]:
                            currentPackage?.key !==
                            AvailablePackages.premium[monthly ? 'monthly' : 'annually'],
                        })}>
                        {currentPackage?.key ===
                        AvailablePackages.premium[monthly ? 'monthly' : 'annually']
                          ? 'SELECTED'
                          : 'SELECT'}
                      </Button>
                    </Col>
                  )}
                </Row>
              </th>
            </tr>

            <tr>
              <td width={'34%'}>Number of free Job Ads</td>

              <td width={'31%'} className={styles.tddleft}>
                NONE
              </td>
              <td />
              {/*<td className={styles.tdd} width={'15.5%'}>*/}
              {/*  4 ads and above at once*/}
              {/*</td>*/}

              <td width={'0.5%'} className={styles.whiteborder} />

              <td className={styles.tdd1} width={'17%'}>
                10 ads per month
              </td>

              <td width={'17%'} className={styles.lastborder}>
                UNLIMITED
              </td>
            </tr>

            <tr>
              <td>Price per Ad(LKR)</td>
              <td className={styles.tddleft}>
                <Row>
                  <Col span={24} className={styles.fontLucids}>
                    LKR <p className={styles.through}>4,000</p> (50% off)
                  </Col>
                  <Col span={24} className={styles.fontLucids}>
                    {' '}
                    LKR 2,000 per ad
                  </Col>
                </Row>
              </td>
              <td />
              {/*<td className={styles.tdd}>*/}
              {/*  <Row>*/}
              {/*    <Col span={24}>*/}
              {/*      LKR <p className={styles.through}>3,000</p> (50% off)*/}
              {/*    </Col>*/}
              {/*    <Col span={24}> LKR 1,500 per ad</Col>*/}
              {/*  </Row>*/}
              {/*</td>*/}
              <td className={styles.whiteborder} />

              <td className={styles.tdd1}>
                <Row>
                  <Col span={24}>
                    {' '}
                    LKR <p className={styles.through}>3,000</p> (50% off)
                  </Col>
                  <Col span={24} className={styles.fontLucids}>
                    {' '}
                    LKR 1,500 per ad<sup>1</sup>
                  </Col>
                </Row>
              </td>

              <td className={styles.lastborder}>FREE</td>
            </tr>

            <tr>
              <td>
                Featured Ads<sup>2</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td>-</td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Price per Boosted Ad<sup>3</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                LKR 250
              </td>
              <td className={styles.whiteborder} />
              <td>LKR 250</td>

              <td className={styles.lastborder}>FEATURED</td>
            </tr>

            <tr>
              <td>
                Duration of Ad<sup>4</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                2 weeks
              </td>
              <td className={styles.whiteborder} />
              <td>4 weeks</td>

              <td className={styles.lastborder}>4 weeks</td>
            </tr>

            <tr>
              <td>Number of Applicants per Ad</td>
              <td colSpan={2} className={styles.tddleft}>
                UNLIMITED
              </td>
              <td className={styles.whiteborder} />
              <td>UNLIMITED</td>

              <td className={styles.lastborder}>UNLIMITED</td>
            </tr>

            <tr>
              <td>Job Applications Management Module</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Applicant Emailing and Email Templates</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Branded Recruiter Profile</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Number of Team Members</td>
              <td colSpan={2} className={styles.tddleft}>
                5
              </td>
              <td className={styles.whiteborder} />
              <td>15</td>

              <td className={styles.lastborder}>UNLIMITED</td>
            </tr>

            <tr>
              <td>Download Job Applications</td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Export Applicants Lists<sup>5</sup>
              </td>
              <td colSpan={2} className={styles.tddleft}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>Recruiter Analytics</td>
              <td colSpan={2} className={styles.tddleft}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>

              <td className={styles.lastborder}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>

            <tr>
              <td>
                Head Hunting (Eyeballing)<sup>6</sup>
              </td>
              <td colSpan={2} className={styles.lastboder1}>
                -
              </td>
              <td className={styles.whiteborder} />
              <td className={styles.lastboder2}>-</td>
              <td className={styles.lastboder3}>
                <CheckCircleFilled style={{ color: '#009E60', fontSize: '20px' }} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <Typography className="text-red-500">
        Note: If you wish to pay in USD please contact us via
        <a className="text-black" href={'tel:+94727360360'}>
          &nbsp;+94 727 360 360
        </a>{' '}
        or
        <a className="text-black" href={'mailto:info@careers360.lk'}>
          &nbsp;info@careers360.lk
        </a>{' '}
        for more details
      </Typography>
      <br />
      <br />
      <div className={styles.items}>
        <Row>
          <Col span={24}>
            <sup>1</sup> additional ad
          </Col>
          <Col span={24}>
            <sup>2</sup> featured ads only available for Premium subscription only
          </Col>
          <Col span={24}>
            <sup>3</sup> dynamically increase the visibility of your advert for a week
          </Col>
          <Col span={24}>
            <sup>4</sup> maximum duration for advert
          </Col>
          <Col span={24}>
            <sup>5</sup> lists will be downloadable in .csv format
          </Col>
          <Col span={24}>
            <sup>6</sup> headhunting allows for recruiters to approach candidates without them
            applying
          </Col>
        </Row>
        <SubscriptionChangeModal ref={subChangeModal} />
      </div>
      {selectedPackage && (
        <div>
          <ResponsiveModal
            title={'Downgrade Subscription Plan'}
            open={downgradeVisible}
            onCancel={() => {
              setDowngradeVisible(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setDowngradeVisible(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to downgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>PAY AS YOU GO</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                You will be downgraded to the new subscription plan and will be charged with the
                total amount of the new downgraded plan at the beginning of the next billing cycle
              </span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14 }}>
                Once the subscription plan downgrade is confirmed, you will not be able to change
                the subscription again until the new subscription plan is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Downgrade Subscription Plan'}
            open={downgradeVisible1}
            onCancel={() => {
              setDowngradeVisible1(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setDowngradeVisible1(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to downgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                You will be downgraded to the new subscription plan and will be charged with the
                total amount of the new downgraded plan at the beginning of the next billing cycle
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                <span style={{ fontWeight: 500 }}>
                  LKR{' '}
                  {monthly
                    ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                    : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                </span>
              </Space>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {monthly
                    ? moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'months').format('MMM Do YYYY')
                    : moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14, color: 'red' }}>
                Once the subscription plan downgrade is confirmed, you will not be able to change
                the subscription again until the new subscription plan is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Upgrade Subscription Plan'}
            open={upgradeVisible1}
            onCancel={() => {
              setUpgradeVisible1(false);
              setSelectedPackage(undefined);
            }}
            okText={'Upgrade'}
            onOk={() => {
              if (onSelect) {
                onSelect?.({
                  subscription: selectedPackage?.name,
                  monthly: monthly,
                  packageId: selectedPackage?.key,
                });
              } else {
                if (recruiterId) {
                  Router.push({
                    pathname: `/recruiter/${recruiterId}/payment`,
                    query: {
                      monthly: monthly,
                      packageId: selectedPackage?.key,
                      price: (
                        selectedPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365) -
                        currentPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365)
                      ).toFixed(0),
                    },
                  });
                }
              }
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to upgrade your plan from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                The Standard Annual Plan subscription fee for the current usage will be deducted
                from the Premium Annual Plan subscription fee and only the prorated total due for
                the upgrade will be charged
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Row
                className={styles.proratedBox}
                gutter={[0, 16]}
                justify="space-around"
                align="middle">
                <Col span={12}>
                  <span>
                    Premium Annual Plan subscription fee × <br />
                    (days left in subscription term / 365)
                  </span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      selectedPackage?.price +
                      ' × ' +
                      '(' +
                      moment(props.package?.renewalDate).diff(moment(), 'days') +
                      '/ 365)'}
                  </span>
                </Col>

                <Col span={12}>
                  <span>
                    (-) Standard Annual Plan subscription fee × <br /> (days left in subscription
                    term / 365)
                  </span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      currentPackage?.price +
                      ' × ' +
                      '(' +
                      moment(props.package?.renewalDate).diff(moment(), 'days') +
                      '/ 365)'}
                  </span>
                </Col>

                <Col span={12}>
                  <span>Prorated Total</span>
                </Col>
                <Col span={2}>
                  <span>=</span>
                </Col>
                <Col span={8}>
                  <span>
                    {'LKR ' +
                      (
                        selectedPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365) -
                        currentPackage?.price *
                          (moment(props.package?.renewalDate).diff(moment(), 'days') / 365)
                      ).toFixed(0)}
                  </span>
                </Col>
              </Row>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {moment().format('MMM Do YYYY') +
                    ' to ' +
                    moment().add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Upgrade Subscription Plan'}
            open={upgradeVisible}
            onCancel={() => {
              setUpgradeVisible(false);
              setSelectedPackage(undefined);
            }}
            okText={'Upgrade'}
            onOk={() => {
              if (onSelect) {
                onSelect?.({
                  subscription: selectedPackage?.name,
                  monthly: monthly,
                  packageId: selectedPackage?.key,
                });
              } else {
                if (recruiterId) {
                  Router.push({
                    pathname: `/recruiter/${recruiterId}/payment`,
                    query: {
                      monthly: monthly,
                      packageId: selectedPackage?.key,
                    },
                  });
                }
              }
            }}>
            <div>
              <div style={{ textAlign: 'center', marginBottom: 6 }}>
                <span>
                  You’re about to upgrade your plan from{' '}
                  <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span> to{' '}
                  <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
                </span>
              </div>
              <div style={{ textAlign: 'center', marginBottom: 6 }}>
                <span style={{ fontSize: 14 }}>
                  You will be upgraded to the new subscription plan instantly and will be charged
                  with the total amount of the new upgraded plan
                </span>
              </div>
              <Space direction={'vertical'} style={{ marginLeft: 22 }}>
                <Space direction={'vertical'}>
                  <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                  <span style={{ fontWeight: 500 }}>
                    LKR{' '}
                    {monthly
                      ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                      : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                  </span>
                </Space>
                <Space direction={'vertical'}>
                  <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                  <span style={{ fontWeight: 500 }}>
                    {monthly
                      ? moment().format('MMM Do YYYY') +
                        ' to ' +
                        moment().add(1, 'months').format('MMM Do YYYY')
                      : moment().format('MMM Do YYYY') +
                        ' to ' +
                        moment().add(1, 'years').format('MMM Do YYYY')}
                  </span>
                </Space>
              </Space>
            </div>
          </ResponsiveModal>
          <ResponsiveModal
            title={'Change Billing Cycle'}
            open={billingCycle}
            onCancel={() => {
              setBillingCycle(false);
              setSelectedPackage(undefined);
            }}
            okText={'Confirm'}
            onOk={() => {
              connection
                .post('subscription/downgrade', {
                  packageId: selectedPackage?.key,
                  recruiterId: props.recruiterId,
                })
                .then(async (res) => {
                  if (res.response.status === 'success') {
                    await Router.push({
                      pathname: `/recruiter/${recruiterId}/subscription-dashboard`,
                    });
                    window.location.reload();
                  }
                })
                .finally(() => {
                  setBillingCycle(false);
                  setSelectedPackage(undefined);
                });
            }}>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span>
                You’re about to change your billing cycle from{' '}
                <span style={{ fontWeight: 'bold' }}>{currentPackage?.name}</span>
                <span style={{ fontWeight: 'bold' }}>
                  {!monthly ? '- Monthly Billing Cycle ' : ' - Annual Billing Cycle '}
                </span>
                to <span style={{ fontWeight: 'bold' }}>{selectedPackage?.name}</span>
              </span>
            </div>
            <div style={{ textAlign: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 14 }}>
                Your billing cycle will be changed and will be charged with the total amount of the
                selected subscription plan for the new billing period instantly.
              </span>
            </div>
            <Space direction={'vertical'} style={{ marginLeft: 22 }}>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>New Billing Amount</span>
                <span style={{ fontWeight: 500 }}>
                  LKR{' '}
                  {monthly
                    ? Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Monthly)'
                    : Utils.formatNumber(selectedPackage?.price, 0) + ' (Billed Annually)'}
                </span>
              </Space>
              <Space direction={'vertical'}>
                <span style={{ fontWeight: 'bold' }}>Billing Period</span>
                <span style={{ fontWeight: 500 }}>
                  {monthly
                    ? moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'months').format('MMM Do YYYY')
                    : moment(props?.package?.renewalDate).format('MMM Do YYYY') +
                      ' to ' +
                      moment(props?.package?.renewalDate).add(1, 'years').format('MMM Do YYYY')}
                </span>
              </Space>
            </Space>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: 14, color: 'red' }}>
                Once the billing cycle change is confirmed, you will not be able to make any changes
                to the subscription again until the new billing cycle is activated at the beginning
                of the next billing cycle
              </span>
            </div>
          </ResponsiveModal>
        </div>
      )}
    </div>
  );
};
